/**
 * top-statistics.jsx
 *
 * @Author: jruif
 * @Date: 2017/7/16 上午2:12
 */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import action from '../../reduxModules/action';
import ajax from '../../util/ajax';
import formatNumber from '../../util/formatNumber';
import './style.scss';

class TopStatistics extends React.PureComponent {
  static propTypes = {
    stone: PropTypes.object,
    user: PropTypes.object,
    url: PropTypes.string,
    className: PropTypes.string,
    showTitle: PropTypes.array,
    isCompany: PropTypes.bool,
    isJump: PropTypes.bool,
  };

  static defaultProps = {
    url: '/general.json',
    showTitle: [
      {
        name: '总订阅',
        key: 'totalSubscribeCount',
        url: '/subscribe-data',
      },
      {
        name: '总阅读',
        key: 'totalReadCount',
        url: '/content-data',
      },
      {
        name: '昨日阅读',
        key: 'yesterdayReadCount',
        url: '/content-data',
      },
      {
        name: '网易号指数',
        key: 'totalIndex',
        url: '/star-level',
      },
    ],
    isJump: false,
  };

  componentDidMount() {
    if (!this.props.data) this.getDataFromAjax();
  }

  componentDidUpdate(preProps) {
    if (!this.props.data && this.props.url !== preProps.url) {
      this.getDataFromAjax();
    }
  }

  getDataFromAjax() {
    const { updateOverview, url } = this.props;
    ajax(url, rs => {
      updateOverview('overview', rs.data);
    });
  }

  render() {
    let { stone, router, showTitle, className, isCompany, isJump, data } = this.props;
    const source = data || stone;
    const search = router.location.search || '';
    return (
      <div className={classnames('top-statistics', className)}>
        {!isCompany &&
          showTitle.map(item => (
            <dl key={'statistics-' + item.key}>
              {isJump && item.url ? (
                <NavLink to={{ pathname: item.url, search: search }} className="top-statistics-link">
                  <dt>{item.name}</dt>
                  <dd>{formatNumber(source ? source[item.key] : '') || '-'}</dd>
                </NavLink>
              ) : (
                [
                  <dt key="name">{item.name}</dt>,
                  <dd key="num">{formatNumber(source ? source[item.key] : '') || '-'}</dd>,
                ]
              )}
            </dl>
          ))}
      </div>
    );
  }
}

export default connect(
  state => ({
    stone: state.statistics.overview,
    router: state.router,
  }),
  dispatch =>
    bindActionCreators(
      {
        updateOverview: action.updateStatistics,
      },
      dispatch,
    ),
)(TopStatistics);
